import React from 'react'
import { AnimatePresence, motion } from 'framer-motion'

interface IPopoverProps extends React.HTMLAttributes<HTMLDivElement> {
  content: React.ReactNode | string
  children: React.ReactNode
  title?: string
  block?: boolean
}

const Popover: React.FC<IPopoverProps & any> = ({
  children,
  content,
  title,
  block,
  ...rest
}) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false)

  const node = React.useRef<HTMLDivElement>(null)

  const handleKeyDown = React.useCallback((e: any) => {
    if (e.keyCode === 27) {
      setIsOpen(false)
    }
  }, [])

  const handleClick = React.useCallback((e: any) => {
    if (!node.current || node.current.contains(e.target)) {
      return
    }

    setIsOpen(false)
  }, [])

  React.useEffect(() => {
    document.addEventListener('keydown', handleKeyDown)
    document.addEventListener('mousedown', handleClick)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
      window.removeEventListener('click', handleClick)
    }
  }, [handleKeyDown, handleClick])

  return (
    <div ref={node} className={`popover-wrapper ${block ? 'block' : ''}`}>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            ref={content}
            transition={{ ease: 'easeOut' }}
            initial={{ opacity: 0, scale: 0.8, x: '-50%' }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            className='popover-content'
            {...rest}
          >
            {content}
          </motion.div>
        )}
      </AnimatePresence>

      <div onClick={() => setIsOpen(!isOpen)}>{children}</div>
    </div>
  )
}

export default Popover
